import { Component, CUSTOM_ELEMENTS_SCHEMA, forwardRef, input, InputSignal } from '@angular/core';
import { BaseFormField } from '../../shared/base-form-field';
import { FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-extra-info-field',
  standalone: true,
  imports: [
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: forwardRef(() => ExtraInfoFieldComponent),
    },
  ],
  templateUrl: './extra-info-field.component.html',
  styleUrls: ['./extra-info-field.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ExtraInfoFieldComponent extends BaseFormField{
  public form: InputSignal<FormGroup> = input.required<FormGroup>();
  public formControlName: InputSignal<string> = input.required<string>();
  
  handleInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this.value = target.value; // from BaseFormField
    this.onChange(target.value); // from BaseFormField
  }
}
